import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NetworkConstants, Trophy } from 'diwimamodelweb/lib';
import { deepCopy } from 'diwimamodelweb/lib/utils/obejct-diff';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { TrophyForm } from '../model/form';
import { TrophyService } from '../trophy.service';
import { UserFeedbackService } from '../user-feedback.service';
import { buildCustomDiff } from 'diwimamodelweb/lib/utils/obejct-diff';


@Component({
  selector: 'app-trophy-form',
  templateUrl: './trophy-form.component.html',
  styleUrls: ['./trophy-form.component.css', '../../app.component.scss']
})
export class TrophyFormComponent implements OnInit {

  @Input() data: TrophyForm
  @Input() formBuilder: FormBuilder
  @Input() userFeedbackService: UserFeedbackService
  @Input() translateService: TranslateService
  @Input() objectService: TrophyService

  isCreate = false

  trophyForm: FormGroup
  oldTrophy: Trophy|undefined

  dropDownTrophyTypes: any[]
  
  constructor() { }

  ngOnInit(): void {
    if (!this.data.data) this.isCreate = true
    this.dropDownTrophyTypes = this.data.constextSettings.get(NetworkConstants.SETTING_TROPY_TYPE).values
    this.trophyForm = this.formBuilder.group({
      tagID: [],
      trophyType: [, Validators.required],
      comment: []
    })
    if (this.data.data) {
      this.isCreate = false
      this.oldTrophy = deepCopy(this.data.data, this.data.data.replacerFn)
      this.initilizeWithData()
    } else {
      this.trophyForm.controls.tagID.disable()
    }
    this.trophyForm.valueChanges.subscribe((value) => {
      const {trophyType, comment} = value
      let objAny = {
        type: trophyType?.identifier,
        typeTitle: trophyType?.title,
        comment
      }
      this.data.data.setFromAny(objAny)
    })
    this.data.onNavBack = this.onCancle
  }

  initilizeWithData() {
    const {type, tagID, comment} = this.data.data
    const sett = this.dropDownTrophyTypes?.find(el => el.identifier == type)
    this.trophyForm.patchValue({
      tagID, comment, trophyType: sett
    })
    this.trophyForm.controls.tagID.disable()
  }

  async onSubmit() {
    if (this.isCreate) {} else {
      try {
        this.userFeedbackService.loading.emit(true)
        const newTrophy = deepCopy(this.data.data, this.data.data.replacerFn)
        const sbSuccessSave = await this.translateService.get('changes_saved').toPromise() 
        await this.objectService.updateTrophy(this.oldTrophy, newTrophy)
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onCancle()
      } catch (error) {
        console.error(error)
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
          }
        )
      }
    }
  }

  onCancle = async () => {
    const newTropy = deepCopy(this.data.data, this.data.data.replacerFn)
    const diff = buildCustomDiff(this.oldTrophy, newTropy)
    if (Object.keys(diff).length == 0) this.data.onCancle()
    else {
      const title = await this.translateService.get('title_unsaved_changes').toPromise()
      const message = await this.translateService.get('msg_unsaved_changes').toPromise()
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title,
          message,
          cancleCallback: async () => {
            const sbChangesDismissed = await this.translateService.get('changes_dismissed').toPromise()
            this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
            this.data.onCancle()
          },
          positiveCallback: async ()=> {
            await this.onSubmit()
            this.data.onSuccessfullySubmitted()
          }
        }
      )
    }
  }

  async onDelete(){
    if(!this.isCreate){
      const title = await this.translateService.get('delete_title').toPromise()
      const message = await this.translateService.get('delete_message').toPromise()  
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title: title,
          message: message,
          cancleCallback: async ()=> {
            const sbCancelDelete = await this.translateService.get('delete_canceled').toPromise() 
            this.userFeedbackService.showSnackBar.emit(sbCancelDelete)

          },
          positiveCallback: async ()=>{
            try{
              this.userFeedbackService.loading.emit(true)
              const sbSuccessDelete = await this.translateService.get('delete_completed').toPromise() 
              await this.objectService.deleteTrophy(this.data.data)
              this.userFeedbackService.loading.emit(false)
              this.userFeedbackService.showSnackBar.emit(sbSuccessDelete)
              this.data.onCancle()
            }catch(errorDelete){
              console.log(errorDelete)
              const sbErrorDelete = await this.translateService.get('delete_error').toPromise() 
              this.userFeedbackService.showSnackBar.emit(sbErrorDelete)

            }
          } 
        }
      )

    }else{
    }
  }
}
